import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { UstawieniaUzytkownikaService } from './api/administracja/systems/ustawienia-uzytkownika.service';

@Injectable({
  providedIn: 'root',
})
export class TimezoneService {
  timezone = new BehaviorSubject<null | string>(null);

  constructor(private readonly ustawieniaUzytkownikaService: UstawieniaUzytkownikaService) {
    this.ustawieniaUzytkownikaService.ustawieniaUzytkownika.subscribe((v) => {
      if (v) {
        this.setTimezone(v.strefaCzasowaNazwa);
      }
    });
  }

  setTimezone(timezoneName: string): void {
    this.timezone.next(timezoneName);
  }
}
